import React from "react";
import { Helmet } from "react-helmet-async";

export const Hreflang: React.FC = () => {
  const baseUrl =
    process.env.REACT_APP_SITE_URL ||
    (typeof window !== "undefined" ? window.location.origin : "");

  const fullPath =
    typeof window !== "undefined"
      ? window.location.pathname + window.location.search
      : "";

  const cleanPath =
    fullPath
      .replace(/^\/(el|en)/, "")
      .replace(/\*+$/, "")
      .replace(/\/+$/, "") || "/";

  const currentLang =
    typeof window !== "undefined" && window.location.pathname.startsWith("/en")
      ? "en"
      : "el";

  const currentUrl = `${baseUrl}/${currentLang}${cleanPath}`;
  const enUrl = `${baseUrl}/en${cleanPath}`;
  const elUrl = `${baseUrl}/el${cleanPath}`;

  return (
    <Helmet>
      <link rel="canonical" href={currentUrl} />
      <link rel="alternate" hrefLang="el" href={elUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={enUrl} />
    </Helmet>
  );
};
